export default __webpack_public_path__ + "static/media/diamond.5f578608.svg";